import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
Vue.prototype.$l = function (key) {
    return Vue.prototype.$t.call(this, `${this.$idg.appid}.${this.$package.name}.${key}`);
};
export const i18n = new VueI18n();
setLanguage('zh-CN');
export function $l(packageInstance, key) {
    return i18n.t(`${packageInstance.idg.appid}.${packageInstance.package.name}.${key}`);
}
function getLanguage() {
    return i18n.locale;
}
function setLanguage(language) {
    i18n.locale = language;
}
const locales = {
    getLanguage,
    setLanguage,
};
export default locales;
